import expertBankLogin from '@/views/expertBank/expertLogin/index.vue'
import expertBankRegister from '@/views/expertBank/expertRegister/index.vue'
import expertBankForgetPwd from '@/views/expertBank/forgetpwd/index.vue'
import expertBankHome from '@/views/expertBank/expertBankHome/index.vue'
import pdfSignBridge from '@/views/sign/pdfSignBridge.vue'

export default [
  {
    path: '/expertBankLogin',
    component: expertBankLogin,
    name: 'expertBankLogin',
  },
  {
    path: '/expertBankRegister',
    component: expertBankRegister,
    name: 'expertBankRegister',
  },
  {
    path: '/expertBankForgetPwd',
    component: expertBankForgetPwd,
    name: 'expertBankForgetPwd',
  },
  {
    path: '/expertBankHome',
    component: expertBankHome,
    name: 'expertBankHome',
  },
  // 签章桥接页（独立路由，供任意页面跳转使用）
  {
    path: '/sign/pdf',
    name: 'pdfSignBridge',
    component: pdfSignBridge
  },
]
